'use strict';
import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import angularFilter from 'angular-filter';
import ngTextTruncate from '../components/ng-text-truncate';
import ngInfiniteScroll from 'ng-infinite-scroll';
import ngIdle from 'ng-idle';
import 'angular-schema-form';
import uiRouter from 'angular-ui-router';
import ngMaterial from 'angular-material';
// import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';
import 'angular-payments';
import 'underscore';
import { routeConfig } from './app.config';
import _Auth from '../components/auth/auth.module';
import mailinglist from '../components/mailinglist';
import common from './common';
import account from './account';
import wptest from './wptest';
import cart from './cart';
import admin from './admin';
import search from './search';
import products from './products';
import education from './education';
import quality from './quality';
import navbar from '../components/navbar';
import discoveremerson from '../components/discoveremerson';
import bannerpopup from '../components/bannerPopup';
import educationsubnav from '../components/education-sub-nav';
import unauthorizedPractitionerError from '../components/unauthorized-practitioner-error';
import hero from '../components/hero/hero.component';
import supportforyourpractice from '../components/supportforyourpractice/supportforyourpractice.component';
import valuepropbar from '../components/valuepropbar/valuepropbar.component';
import footer from '../components/footer';
import main from './main/main.component';
import wireframe from './wireframe';
import signup from './account/signup';
import util from '../components/util/util.module';
import PageLevelAlertMessaging from '../components/page-level-alert-messaging';
import SiteAlertMessaging from '../components/site-alert-messaging';
import paging from '../components/paging';
import support from './support';
import brands from './brands';
import expansionPanel from '../components/expansion-panel';
import { DirectivesModule } from './directives/directives.module';
import { WelcomeSplashModule } from '../components/welcome-splash/welcome-splash.module';
import { InfoCardModule } from '../components/info-card/info-card.module';
import { CSAModule } from './csa/csa.module';
import { AccountOrdersModule } from './account/orders/orders.module';
import { ProgressSpinnerModule } from '../components/progress-spinner/progress-spinner.module';
import { Autocomplete } from '../components/autocomplete/autocomplete.module';
import { ProgressLinear } from '../components/progress-linear/progress-linear.module';
import ShowMoreLessModule from '../components/show-more-less';
import { NewAddressFormModule } from '../components/new-address-form/new-address-form.module';
import quantityFreeshipping from '../components/quantity-freeshipping';
import { AppLoadTiming } from '../marketing/app-load-timing';
import './app.less';
angular.module('eeComUiApp', [ngCookies, ngAnimate, ngResource, ngSanitize, uiRouter, common, ngIdle,
    ngMaterial, _Auth, mailinglist, bannerpopup, account, wptest, cart, admin, search, products, navbar, hero, discoveremerson, supportforyourpractice, valuepropbar,
    footer, main, wireframe, signup, util, angularFilter, ngTextTruncate, ngInfiniteScroll, PageLevelAlertMessaging, SiteAlertMessaging, education, quality, brands, educationsubnav, support, paging,
    unauthorizedPractitionerError, expansionPanel, DirectivesModule, WelcomeSplashModule, InfoCardModule, CSAModule,
    AccountOrdersModule, ProgressSpinnerModule, Autocomplete, ProgressLinear, NewAddressFormModule, ShowMoreLessModule,
    quantityFreeshipping
])
    .directive('compile', ['$compile', function ($compile) {
        return function (scope, element, attrs) {
            scope.$watch(function (scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            }, function (value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);
                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
            });
        };
    }])
    .filter('zipcode', function () {
    return function (input) {
        if (!input) {
            return input;
        }
        if (String(input).length === 9) {
            return String(input).slice(0, 5) + "-" + String(input).slice(5);
        }
        else if (String(input).length === 5) {
            return String(input);
        }
        return input;
    };
})
    .value('appLoadTiming', AppLoadTiming)
    .config(routeConfig)
    .config(function (IdleProvider) {
    'ngInject';
    // Configure idle timeout settings (in seconds).
    IdleProvider.idle(3540);
    IdleProvider.timeout(60);
})
    .config(function ($httpProvider) {
    'ngInject';
    // This is added to disable caching in Internet Explorer Browser AJAX Caching
    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }
    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    $httpProvider.interceptors.push(function ($window) {
        'ngInject';
        return {
            request: function (req) {
                var timeoutMillis = 60000;
                if ((req.method == 'POST' || req.method == 'PUT') &&
                    (req.url.startsWith('/api/account/credentials') ||
                        req.url.startsWith('/api/account/rx'))) {
                }
                else {
                    req.timeout = timeoutMillis; // Global request timeout
                }
                return req;
            }
        };
    });
    // set universal timeout
    $httpProvider.interceptors.push(function ($rootScope, $q) {
        'ngInject';
        return {
            request: function (config) {
                config.timeout = 30000;
                return config;
            },
            responseError: function (response) {
                if (response.status === -1)
                    return $q.reject(response);
                if (response.status === 401 && $rootScope.shouldRedirectToLogin) {
                    $rootScope.$broadcast('unauthorized'); // $on is fired off in Auth.service
                }
                return response;
            }
        };
    });
}).run(function ($rootScope, $q, newRelicService, $location, Auth, $window, $document, $cookies, $anchorScroll, $mdDialog, Idle) {
    'ngInject';
    newRelicService.captureSessionContext();
    // Enable idle timeout if you're logged in.
    var dialogOpen = false;
    Auth.getGenesysChatConfig().then(function (data) {
        localStorage.setItem("genesysconfig", JSON.stringify(data));
    });
    Auth.isLoggedIn(function (loggedInUser) {
        if (loggedInUser) {
            setTimeout(function () {
                $zopim(function () {
                    $zopim.livechat.setName(loggedInUser.firstName + ' ' + loggedInUser.lastName || '');
                    $zopim.livechat.setEmail(loggedInUser.email);
                });
            }, 9000);
            $rootScope.userInfo = {
                accountType: loggedInUser.accountType
            };
            Idle.watch();
        }
    });
    $rootScope.$on("IdleTimeout", function () { return Auth.logout(); });
    $rootScope.$on("IdleStart", function (ev) {
        if (!dialogOpen) {
            dialogOpen = true;
            $mdDialog
                .show($mdDialog.confirm()
                .title("Session Expiration")
                .textContent("Your session is about to expire.")
                .ariaLabel("Idle Timeout")
                .targetEvent(ev)
                .ok("Stay Logged In")
                .cancel("Log Out"))
                .then(function () {
                Auth.refreshToken().then(function (response) { return console.log('Stay logged in refreshToken Success: ', response); });
            }, function () {
                console.log('Log out initiated');
                Auth.logout();
            })
                .catch(function (err) {
                console.log('Log out initiated by session expression dialog error: ', err);
                Auth.logout();
            })
                .finally(function () { return dialogOpen = false; });
        }
    });
    $rootScope.$on('$locationChangeSuccess', function () {
        if (window.om78096_69475) {
            window.om78096_69475.reset();
        }
    });
    $rootScope.$on('$locationChangeStart', function (event, next, current) {
        var currurl = $location.path();
        //Adding logic to restrict URL modification only for Search
        if (currurl.split('/')[1].toUpperCase() === 'SHOP' & currurl.indexOf('_') > -1) {
            var newurl = currurl.replace(/_/g, '-');
            event.preventDefault();
            $window.location = newurl;
        }
        var nonce = $location.search().nonce;
        if (nonce) {
            Auth.nonceLogin(nonce).subscribe();
        }
        var visitorPath;
        visitorPath = sessionStorage.getItem('visitorPath');
        if (visitorPath) {
            visitorPath = JSON.parse(visitorPath);
        }
        else {
            visitorPath = [];
        }
        var lastUrl = visitorPath.length ? visitorPath[visitorPath.length - 1] : '';
        if (lastUrl !== next) {
            if (visitorPath.length > 4) {
                visitorPath.shift();
                visitorPath.push(next);
            }
            else {
                visitorPath.push(next);
            }
            sessionStorage.setItem('visitorPath', JSON.stringify(visitorPath));
        }
    });
    // On state change, redirect to login if route requires auth and you're not logged in.
    $rootScope.$on('$stateChangeStart', function (event, next) {
        //If it's logout then don't do any authentication
        if (next.name == 'logout') {
            return;
        }
        $cookies.put('eeprevurl', $location.path());
        var cpid = $location.search().cpid || $location.search().CPID;
        var referrer = $document[0].referrer;
        if (cpid) {
            if (referrer) {
                cpid = cpid + ';' + referrer;
            }
            $cookies.put('cpid', cpid);
        }
        ;
        Auth.isLoggedIn(function (loggedInUser) {
            if (next.authenticate && !loggedInUser) {
                $window.location = '/auth/ares';
            }
            if (next.practitionerOnly && loggedInUser && ("" + loggedInUser.accountType).toLowerCase() != 'practitioner') {
                $window.location = '/auth/ares';
            }
        });
        $anchorScroll();
    });
    $rootScope.saveTopValOnModalOpen = function () {
        sessionStorage.setItem('modalScrollTop', $window.pageYOffset);
    };
    $rootScope.retainPosOnModalClose = function () {
        $window.scroll(0, parseInt(sessionStorage.getItem('modalScrollTop')));
        sessionStorage.removeItem('modalScrollTop');
    };
});
export default 'eeComUiApp';
//# sourceMappingURL=app.angularjs.js.map